var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('form',{attrs:{"onsubmit":"return false"},on:{"submit":_vm.handleSearch}},[_c('input',{attrs:{"type":"search","title":_vm.$t('searchDApps'),"placeholder":_vm.$t('searchDApps'),"value":"","required":""}}),_vm._v(" "),_c('button',[_c('a-icon',{attrs:{"type":"search"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29208f91","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/DAppSearchBox.vue
// module id = null
// module chunks = 